import React from "react";
import { Link } from "react-router-dom";
import { 
  Battery, 
  Zap, 
  Shield, 
  TrendingUp, 
  Award, 
  Users, 
  Factory, 
  Leaf,
  Clock,
  CheckCircle,
  Download,
  Play,
  ArrowRight,
  Star,
  BatteryCharging,
  Cpu,
  Globe,
  Lightbulb
} from "lucide-react";

import lithiumbanner from "../img/services/lithium/lithium-banner.jpg";
import wheeler3wheelerbatteries from "../img/services/lithium/lithium-banner.jpg";
import lithiumbatterymanufacturing from "../img/services/lithium/lithium-battery-manufacturing.jpg";
import lithiumbatteryproduct1 from "../img/services/lithium/combbattery.jpeg";
import lithiumbatteryproduct2 from "../img/services/lithium/24vdisplay.jpeg";
import lithiumbatteryproduct3 from "../img/services/lithium/12vdisplay.jpeg";
import lithiumbatteryproduct4 from "../img/services/lithium/12vbattimg.jpeg";
import lithiumbatteryproduct5 from "../img/services/lithium/twowheeler.jpg";
import lithiumbatteryproduct6 from "../img/services/lithium/24vbatimg.jpeg";
import lithiumbatteryproduct7 from "../img/services/lithium/sixth (6).jpg";
import lithiumbatteryproduct8 from "../img/services/lithium/whitebatteries.jpg.jpeg";
import lithiumbatteryproduct9 from "../img/services/lithium/withdisplay.jpg";
import lithiumbatteryproduct10 from "../img/services/lithium/withoutdisplay (1).jpg";

import lithiumVideo from "../video/lithiumvideo.mp4";
import LithiumCatalogue from '../catalogues/lithium/Lithium-battery-16-pages-V1.pdf';
import LithiumIonBattery from '../catalogues/final-V1.pdf';
import Bessandess from '../catalogues/(V3).pdf';
import Lithiumbatteryvideo from "../video/1730806203537.mp4";

function Lithiumbattery() {
  const products = [
    {
      title: "2-Wheeler Batteries",
      description: "High-performance lithium batteries for electric motorcycles and scooters",
      icon: Battery,
      gradient: "from-blue-500 to-cyan-600"
    },
    {
      title: "3-Wheeler Batteries",
      description: "Powerful solutions for auto-rickshaws and commercial three-wheelers",
      icon: BatteryCharging,
      gradient: "from-green-500 to-emerald-600"
    },
    {
      title: "Telecom Batteries",
      description: "Reliable backup power for telecommunications infrastructure",
      icon: Globe,
      gradient: "from-purple-500 to-indigo-600"
    },
    {
      title: "ESS Solutions",
      description: "Energy Storage Systems for residential and commercial applications",
      icon: Cpu,
      gradient: "from-orange-500 to-red-600"
    },
    {
      title: "UPS Systems",
      description: "Uninterruptible Power Supply for critical applications",
      icon: Shield,
      gradient: "from-pink-500 to-rose-600"
    },
    {
      title: "Data Center",
      description: "High-density power solutions for data center operations",
      icon: Factory,
      gradient: "from-teal-500 to-cyan-600"
    }
  ];

  const features = [
    {
      title: "Enhanced Performance",
      description: "Superior power delivery and efficiency for optimal performance",
      icon: TrendingUp,
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      title: "Cost-Effective",
      description: "Long-term savings with reduced maintenance and replacement costs",
      icon: Award,
      gradient: "from-green-500 to-emerald-600"
    },
    {
      title: "Eco-Friendly",
      description: "Sustainable energy solutions with minimal environmental impact",
      icon: Leaf,
      gradient: "from-emerald-500 to-teal-600"
    },
    {
      title: "Advanced Technology",
      description: "Cutting-edge battery management and monitoring systems",
      icon: Cpu,
      gradient: "from-purple-500 to-pink-600"
    }
  ];

  const catalogues = [
    {
      title: "Complete Lithium Catalogue",
      subtitle: "16 pages comprehensive guide",
      icon: Download,
      file: LithiumCatalogue
    },
    {
      title: "Lithium-Ion Batteries Catalogue",
      subtitle: "Technical specifications",
      icon: Battery,
      file: LithiumIonBattery
    },
    {
      title: "Custom ESS/BESS Solutions",
      subtitle: "Tailored energy storage systems",
      icon: Factory,
      file: Bessandess
    }
  ];

  const galleryImages = [
    lithiumbatteryproduct1,
    lithiumbatteryproduct2,
    lithiumbatteryproduct3,
    lithiumbatteryproduct4,
    lithiumbatteryproduct5,
    lithiumbatteryproduct6,
    lithiumbatteryproduct7,
    lithiumbatteryproduct8,
    lithiumbatteryproduct9,
    lithiumbatteryproduct10
  ];

  return (
    <div className="home-container">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-green-400/20 to-blue-600/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-cyan-400/20 to-green-600/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-gradient-to-br from-blue-400/10 to-purple-600/10 rounded-full blur-3xl"></div>
      </div>

      {/* Hero Section - Rich with Colors and Effects */}
      <section className="pt-24 pb-16 px-4 sm:px-6 text-center relative overflow-hidden" style={{marginTop: "30px"}}>
        {/* Rich Background Layers */}
        <div className="absolute inset-0 bg-gradient-to-br from-green-100 via-white to-blue-100 opacity-60"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-100/40 via-transparent to-transparent"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          {/* Enhanced Feature Pill with Gradient */}
          <div className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-3 bg-gradient-to-r from-green-500 to-blue-600 rounded-full text-xs sm:text-sm font-medium text-white mb-6 sm:mb-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
            <Battery className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-300" />
            <span className="bg-gradient-to-r from-yellow-200 to-yellow-100 bg-clip-text text-transparent font-bold">
              Advanced
            </span>{" "}
            Lithium Technology
            <Zap className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-300 animate-pulse" />
          </div>

          {/* Rich Main Headline with Multiple Gradients */}
          <h1 className="text-4xl sm:text-5xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter mb-6 sm:mb-8 leading-tight">
            <span className="bg-gradient-to-r from-slate-900 via-green-900 to-slate-900 bg-clip-text text-transparent">
              Lithium ESS-Battery Manufacturing
            </span>
            <br />
            <span className="bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 bg-clip-text text-transparent">
              Facility
            </span>
          </h1>

          {/* Enhanced Subtext with Gradient */}
          <p className="text-lg sm:text-xl text-slate-600 mb-12 sm:mb-16 max-w-4xl mx-auto leading-relaxed bg-gradient-to-r from-slate-600 to-slate-500 bg-clip-text text-transparent px-4">
            Powering the future with cutting-edge lithium battery technology for electric vehicles, 
            telecommunications, and energy storage systems with unmatched efficiency and reliability.
          </p>

          {/* Rich Stats with Gradient Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto mb-16 sm:mb-20">
            <div className="group relative bg-gradient-to-br from-white to-green-50 border border-green-200/50 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-green-400/10 to-blue-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-black bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent mb-2 sm:mb-3">
                  50+
                </div>
                <div className="text-slate-600 text-sm sm:text-base font-semibold">
                  Battery Models
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-3 h-3 sm:w-4 sm:h-4 bg-gradient-to-br from-green-400 to-blue-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-emerald-50 border border-emerald-200/50 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 to-teal-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-black bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-2 sm:mb-3">
                  15+
                </div>
                <div className="text-slate-600 text-sm sm:text-base font-semibold">
                  Years Experience
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-3 h-3 sm:w-4 sm:h-4 bg-gradient-to-br from-emerald-400 to-teal-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-blue-50 border border-blue-200/50 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400/10 to-indigo-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-black bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2 sm:mb-3">
                  98%
                </div>
                <div className="text-slate-600 text-sm sm:text-base font-semibold">
                  Efficiency Rate
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-3 h-3 sm:w-4 sm:h-4 bg-gradient-to-br from-blue-400 to-indigo-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-purple-50 border border-purple-200/50 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-400/10 to-pink-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-black bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-2 sm:mb-3">
                  Quick
                </div>
                <div className="text-slate-600 text-sm sm:text-base font-semibold">
                  Support
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-3 h-3 sm:w-4 sm:h-4 bg-gradient-to-br from-purple-400 to-pink-600 rounded-full"></div>
            </div>
          </div>
        </div>
      </section>
    
      {/* Product Table */}
      <section className="py-12 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6 md:p-8 shadow-lg">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-800">
              Lithium Battery Inverter Product Range with It's specifications
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-lg shadow-md overflow-hidden">
                <thead>
                  <tr className="bg-gradient-to-r from-green-600 to-blue-600 text-white">
                    <th className="py-3 px-4 text-left font-semibold">Lithium Inverter with Lithium Battery</th>
                    <th className="py-3 px-4 text-left font-semibold">Solar Inverter with Lithium Battery</th>
                    <th className="py-3 px-4 text-left font-semibold">Batteries</th>
                    <th className="py-3 px-4 text-left font-semibold">Deye Hybrid Inverters with Finike Lithium Batteries</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=1100VA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">1100VA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=1100VAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">1100VAsolar</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=12.8V105Ah" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">12.8V105Ah Lithium Battery</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=3kwhybridsinglephase-25.6V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">3kwhybridsinglephase-25.6V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=2100VA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">2100VA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=2100VAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">2100VAsolar</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=12.8V210Ah" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">12.8V210Ah Lithium Battery</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=3kwhybridsinglephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">3kwhybridsinglephase-51.2V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=2500VA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">2500VA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=2500VAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">2500VAsolar</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=25.6V105Ah" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">25.6V105Ah Lithium Battery</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=3.6kwhybridsinglephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">3.6kwhybridsinglephase-51.2V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=3.5KVA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">3.5KVA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=3.5KVAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">3.5KVAsolar</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=25.6V210Ah" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">25.6V210Ah Lithium Battery</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=5kwhybridsinglephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">5kwhybridsinglephase-51.2V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=5KVA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">5KVA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=5KVAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">5KVAsolar</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=51.2V105Ah" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">51.2V105Ah Lithium Battery</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=5kwhybridthreephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">5kwhybridthreephase-51.2V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=7.5KVA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">7.5KVA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=7.5KVAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">7.5KVAsolar</a></td>
                    <td className="py-2 px-4"></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=6kwhybridsinglephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">6kwhybridsinglephase-51.2V</a></td>
                  
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=10KVA" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">10KVA</a></td>
                    <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=10KVAsolar" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">10KVAsolar</a></td>
                    <td className="py-2 px-4"></td>
                  <td className="py-2 px-4"><a href="https://finikelithium.com/shop-online?category=6kwhybridthreephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">6kwhybridthreephase-51.2V</a></td>
                  </tr>

                   <tr className="border-b hover:bg-gray-50">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><a href="https://finikelithium.com/shop-online?category=8kwhybridsinglephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">8kwhybridsinglephase-51.2V</a></td>
                  </tr>
                   <tr className="border-b hover:bg-gray-50">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><a href="https://finikelithium.com/shop-online?category=8kwhybridthreephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">8kwhybridthreephase-51.2V</a></td>
                  </tr>
                   <tr className="border-b hover:bg-gray-50">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><a href="https://finikelithium.com/shop-online?category=10kwhybridthreephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">10kwhybridthreephase-51.2V</a></td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><a href="https://finikelithium.com/shop-online?category=12kwhybridthreephase-51.2V" className="text-blue-600 hover:text-blue-800 hover:underline font-medium" target="_blank">12kwhybridthreephase-51.2V</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Product Gallery */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 right-10 w-64 h-64 bg-green-100/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 left-10 w-80 h-80 bg-blue-100/15 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 rounded-full text-green-600 font-semibold text-sm mb-6">
              <Battery className="w-4 h-4" />
              PRODUCT GALLERY
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Our <span className="highlight-gradient">Lithium Battery</span> Collection
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Explore our comprehensive range of lithium battery solutions designed for various applications
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05) translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1) translateY(0)";
                }}
              >
                <img
                  src={image}
                  alt={`Lithium Battery Product ${index + 1}`}
                  className="w-full h-32 md:h-40 object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-2">
                  <span className="text-white text-xs font-semibold">
                    Model {index + 1}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Manufacturing Section */}
      <section className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-slate-950 via-slate-900 to-black relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 right-10 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-green-600/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 left-10 w-40 h-40 sm:w-60 sm:h-60 md:w-80 md:h-80 bg-blue-600/8 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Main container */}
          <div className="bg-gradient-to-b from-slate-900/92 to-slate-950/92 backdrop-blur-md rounded-xl sm:rounded-2xl md:rounded-3xl p-4 sm:p-6 lg:p-8 xl:p-10 xl:p-12 shadow-2xl shadow-black/60">

            <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 xl:gap-10">
              {/* Left column */}
              <div className="lg:col-span-12 space-y-8 lg:space-y-10 lg:space-y-12">

                {/* Features */}
                <div>
                  <h3 className="text-xl lg:text-2xl xl:text-3xl font-bold text-white mb-4 lg:mb-6 text-center">
                    Advantages of Choosing Finike Lithium Batteries
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
                    {features.map((feature, idx) => {
                      const Icon = feature.icon;
                      return (
                        <div
                          key={idx}
                          className="group p-4 sm:p-5 lg:p-6 rounded-xl bg-slate-800/40 hover:bg-slate-800/60 transition-all duration-300 flex flex-col items-center text-center shadow-md lg:shadow-lg"
                        >
                          <div
                            className={`w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br ${feature.gradient} rounded-xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform shadow-lg`}
                          >
                            <Icon className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-white text-sm sm:text-base lg:text-lg mb-2">
                            {feature.title}
                          </h4>
                          <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
                            {feature.description}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>

            
              </div>

              {/* Right column */}
              <div className="lg:col-span-12 space-y-8 lg:space-y-10 lg:space-y-12">

                {/* Product Categories */}
                <div>
                  <h3 className="text-xl lg:text-2xl xl:text-3xl font-bold text-white mb-4 lg:mb-6 text-center">
                    Our Product Categories
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-5">
                    {products.map((product, idx) => {
                      const Icon = product.icon;
                      return (
                        <div
                          key={idx}
                          className="group p-4 sm:p-5 lg:p-6 rounded-xl bg-slate-800/40 hover:bg-slate-800/60 transition-all duration-300 flex flex-col items-center text-center shadow-md lg:shadow-lg"
                        >
                          <div
                            className={`w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br ${product.gradient} rounded-xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform shadow-lg`}
                          >
                            <Icon className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-white text-sm sm:text-base lg:text-lg mb-2">
                            {product.title}
                          </h4>
                          <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
                            {product.description}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Catalogues Block */}
      <section
        className="brands"
        style={{ padding: "60px 0", background: "#fafafa" }}
      >
        <div className="max-w">
          <div
            className="section-head"
            style={{ marginBottom: "40px", textAlign: "center" }}
          >
            <div
              style={{
                display: "inline-flex",
                padding: "8px",
                background: "rgba(34,197,94,0.05)",
                borderRadius: "12px",
                color: "#22c55e",
                marginBottom: "16px",
              }}
            >
              <Download size={24} />
            </div>
            <h2
              style={{
                fontSize: "28px",
                fontWeight: "900",
                letterSpacing: "-1px",
              }}
            >
              Product <span className="highlight-gradient">Catalogues.</span>
            </h2>
            <p style={{ fontSize: "16px", color: "#64748b", marginTop: "8px" }}>
              Download our comprehensive product catalogues and technical specifications
            </p>
          </div>

          <div className="row">
            {catalogues.map((catalogue, index) => (
              <div className="col-md-4" key={index}>
                <div className="icon-box">
                  <div
                    className="wt-icon-box-wraper center"
                    style={{
                      background: "white",
                      padding: "30px",
                      borderRadius: "20px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
                    }}
                  >
                    <div
                      className="icon-md inline-block"
                      style={{
                        background: "linear-gradient(135deg, #22c55e, #3b82f6)",
                        borderRadius: "15px",
                        marginBottom: "20px",
                        padding: "15px",
                      }}
                    >
                      <Download color="white" size={32} />
                    </div>
                    <div className="icon-content">
                      <h5
                        className="text-2xl font-bold mb-3"
                        style={{ color: "#1e293b" }}
                      >
                        {catalogue.title}
                      </h5>
                      <p
                        className="text-gray-600 mb-4"
                        style={{ fontSize: "14px" }}
                      >
                        {catalogue.subtitle}
                      </p>
                      <a
                        href={catalogue.file}
                        className="btn-block"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          background: "linear-gradient(135deg, #22c55e, #3b82f6)",
                          color: "white",
                          padding: "12px 24px",
                          borderRadius: "10px",
                          textDecoration: "none",
                          fontWeight: "600",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                          e.currentTarget.style.boxShadow = "0 5px 15px rgba(34,197,94,0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <Download size={16} />
                        Download PDF
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Power Your Future with Lithium?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Join the revolution in sustainable energy solutions. Contact us today to discuss your lithium battery requirements.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact-us"
              className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-xl"
            >
              Get Quote
              <ArrowRight className="w-5 h-5" />
            </Link>
            <a
              href="https://wa.link/jb4lfe"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:scale-105"
            >
              Chat with Expert
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Lithiumbattery;
